<template>
    <div id="app">
      <router-view/>
    </div>
</template>

<script>
export default {
  name: 'app',
  components: {
      
  },
  mounted() {
    const script = document.createElement('script')
    script.src = 'https://s9.cnzz.com/z_stat.php?id=1278708975&web_id=1278708975'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  }
}
</script>

<style lang="less">
@import "./style/common";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  position: relative;
}
</style>
